/**
 * Maps English characters typed on a Hebrew keyboard layout back to Hebrew.
 * e.g. "euneuo" (typed meaning "מוצרים") → "מוצרים"
 */

const enToHe: Record<string, string> = {
  q: "/", w: "'", e: "ק", r: "ר", t: "א", y: "ט", u: "ו", i: "ן", o: "ם", p: "פ",
  a: "ש", s: "ד", d: "ג", f: "כ", g: "ע", h: "י", j: "ח", k: "ל", l: "ך",
  z: "ז", x: "ס", c: "ב", v: "ה", b: "נ", n: "מ", m: "צ",
  ",": "ת", ".": "ץ", ";": "ף",
  Q: "/", W: "'", E: "ק", R: "ר", T: "א", Y: "ט", U: "ו", I: "ן", O: "ם", P: "פ",
  A: "ש", S: "ד", D: "ג", F: "כ", G: "ע", H: "י", J: "ח", K: "ל", L: "ך",
  Z: "ז", X: "ס", C: "ב", V: "ה", B: "נ", N: "מ", M: "צ",
};

/** Returns true if the string looks like it was typed on an English keyboard */
function isLatinOnly(s: string): boolean {
  return /^[a-zA-Z0-9\s,.\-;'"\/]+$/.test(s);
}

/** Convert English-keyboard-typed text to Hebrew */
export function englishToHebrew(input: string): string {
  return input
    .split("")
    .map((ch) => enToHe[ch] ?? ch)
    .join("");
}

/**
 * If the query looks like it was typed in English on a Hebrew keyboard,
 * return the Hebrew transliteration. Otherwise return null.
 */
export function detectAndConvert(query: string): string | null {
  const trimmed = query.trim();
  if (!trimmed || !isLatinOnly(trimmed)) return null;
  const converted = englishToHebrew(trimmed);
  // Only return if conversion produced Hebrew characters
  if (/[\u0590-\u05FF]/.test(converted)) return converted;
  return null;
}
